import React, { useEffect, useRef, useState } from "react";
import styles from "../User/style.module.css";
import Header from "../../partials/ExternalHeader";
import CalDel from "../../../images/cal-del.png";
import { useNavigate, useParams } from "react-router-dom";
import { notification } from "antd";
import loaderIcon from "../../../assets/icons/Spinner-1s-200px.svg";
import "./keyboard.css";

const url = process.env.REACT_APP_APP_BACK_URL;

const alphaLayout = [
  ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["Z", "X", "C", "V", "B", "N", "M"],
  ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"],
  ["-", "_", "+", "=", "[", "]", "{", "}", "/", "\\"],
  [".", ",", ":", ";", "?", "'", "\"", "`", "~", "|"],
  ["<", ">"],
  ["Delete", "Space", "Clear", "Enter"],
];

const DepartmentUniversal = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [code, setCode] = useState("");
  const [keyboardMode, setKeyboardMode] = useState("numeric");
  const [isLoading, setIsLoading] = useState(false);
  const [department, setDepartment] = useState(null);
  const [lockers, setLockers] = useState([]);
  const codeInputRef = useRef(null);
  const barcodeInputRef = useRef(null);
  const submittingRef = useRef(false);
  const [barcode, setBarcode] = useState("");

  useEffect(() => {
    if (codeInputRef.current) codeInputRef.current.focus();
  }, [department]);

  const handleKey = (key) => {
    if (key === "Delete" || key === "Backspace") {
      setCode((prev) => prev.slice(0, -1));
    } else if (key === "Space") {
      setCode((prev) => prev + " ");
    } else if (key === "Clear") {
      setCode("");
    } else if (key === "Enter") {
      submitCode(code);
    } else {
      setCode((prev) => prev + key);
    }
  };

  const submitCode = async (rawCode) => {
    const entered = String(rawCode || "").trim();
    if (!entered || submittingRef.current) {
      if (!entered) {
        notification.error({
          message: "Failed",
          description: "Please enter your universal pickup code",
          duration: 3,
        });
      }
      return;
    }
    submittingRef.current = true;
    setIsLoading(true);
    try {
      const response = await fetch(`${url}/api/department/universal`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: entered, slug }),
      });
      const json = await response.json();
      if (!json.success) {
        notification.error({
          message: "Invalid universal code",
          description: json.error || "This universal code is not valid for this location.",
          duration: 4,
        });
        return;
      }
      setDepartment(json.department || { name: "Department" });
      setLockers(Array.isArray(json.lockers) ? json.lockers : []);
      setCode("");
    } catch (error) {
      notification.error({
        message: "Unable to continue",
        description: "We could not check this code. Please try again.",
        duration: 4,
      });
    } finally {
      setIsLoading(false);
      submittingRef.current = false;
    }
  };

  useEffect(() => {
    let interval;
    const handleKeyDown = (evt) => {
      if (department) return;
      if (evt.target && evt.target.tagName === "INPUT") return;
      if (interval) clearInterval(interval);
      if (evt.code === "Enter") {
        if (barcode) submitCode(barcode);
        setBarcode("");
        return;
      }
      if (evt.key && evt.key.length === 1) {
        setBarcode((prev) => prev + evt.key);
      }
      interval = setInterval(() => setBarcode(""), 20);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (interval) clearInterval(interval);
    };
  }, [barcode, department]);

  if (isLoading) {
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <img src={loaderIcon} alt="" />
      </div>
    );
  }

  return (
    <div className={styles.heading}>
      <div className="body-wrap">
        <div className="container-fluid px-0">
          <Header />
          {!department && (
            <div className=" d-flex justify-content-center  ">
              <div className="mt-5 mb-1 text-center ">
                <img
                  src="/arrow.png"
                  height={70}
                  width={70}
                  alt=""
                  onError={(e) => {
                    e.target.src = "/placeholder.png";
                  }}
                />
                <br />
                <button type="button" className="btn btn-prim w-auto py-3 mt-2">
                  Scan QR Code
                </button>
                <h3 className="mt-2">OR</h3>
              </div>
            </div>
          )}
          <div className={styles.body_wrap}>
            <div className="mt-1">
              <div className="calc-wrap-main">
                <div className="row text-center">
                  {!department && (
                    <input
                      type="text"
                      ref={barcodeInputRef}
                      style={{
                        opacity: 0,
                        position: "absolute",
                        left: "-9999px",
                      }}
                      onChange={(e) => setBarcode(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          submitCode(e.target.value);
                          e.target.value = "";
                          setBarcode("");
                        }
                      }}
                      autoFocus
                    />
                  )}
                  <div className="col-lg-12">
                    <div className="calc-wrap">
                      {department ? (
                        <div className="px-3 py-4">
                          <h3 className="mb-1">{department.name}</h3>
                          <p className="mb-4">Select a locker to open</p>
                          {lockers.length === 0 ? (
                            <p>No lockers are assigned to this department.</p>
                          ) : (
                            <div className="d-flex flex-column align-items-center gap-2">
                              {lockers.map((locker) => (
                                <button
                                  key={locker._id}
                                  type="button"
                                  className="btn btn-prim w-auto"
                                  onClick={() =>
                                    navigate(`/${slug}/locker/open/${locker._id}`)
                                  }
                                >
                                  Locker #{locker.number}
                                  {locker.size ? ` · ${locker.size}` : ""}
                                </button>
                              ))}
                            </div>
                          )}
                          <div className="cont-btn-wrap mt-4">
                            <button
                              type="button"
                              className="continue-btn"
                              onClick={() => {
                                setDepartment(null);
                                setLockers([]);
                              }}
                            >
                              Enter a different code
                            </button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="cal-screen">
                            <input
                              type="text"
                              id="universal-code"
                              ref={codeInputRef}
                              value={code}
                              placeholder="Enter Universal Code"
                              onChange={(e) => setCode(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  submitCode(code);
                                }
                              }}
                              autoComplete="off"
                              autoFocus
                            />
                          </div>
                          <div className="keys-wrap">
                            <div className="mb-2">
                              <button
                                type="button"
                                className="btn btn-prim w-auto"
                                onClick={() =>
                                  setKeyboardMode((mode) =>
                                    mode === "numeric" ? "alphanumeric" : "numeric"
                                  )
                                }
                              >
                                {keyboardMode === "numeric"
                                  ? "Use Letters & Symbols"
                                  : "Use Numeric Keypad"}
                              </button>
                            </div>
                            {keyboardMode === "numeric" ? (
                              <div className="row">
                                {[
                                  ["1", ""],
                                  ["2", "ABC"],
                                  ["3", "DEF"],
                                  ["4", "GHI"],
                                  ["5", "JKL"],
                                  ["6", "MNO"],
                                  ["7", "PQRS"],
                                  ["8", "TUV"],
                                  ["9", "WXYZ"],
                                ].map(([digit, letters]) => (
                                  <div className="col-4" key={digit}>
                                    <button
                                      type="button"
                                      className="btn-key"
                                      onClick={() => handleKey(digit)}
                                    >
                                      <i>{digit}</i>
                                      {letters ? <span>{letters}</span> : null}
                                    </button>
                                  </div>
                                ))}
                                <div className="col-8">
                                  <button
                                    type="button"
                                    className="btn-key"
                                    onClick={() => handleKey("0")}
                                  >
                                    <i>0</i>
                                  </button>
                                </div>
                                <div className="col-4">
                                  <button
                                    type="button"
                                    className="btn-delt"
                                    onClick={() => handleKey("Delete")}
                                  >
                                    <img src={CalDel} alt="" />
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="order-alpha-keyboard">
                                {alphaLayout.map((row, rowIndex) => (
                                  <div
                                    key={rowIndex}
                                    className="order-alpha-keyboard-row"
                                  >
                                    {row.map((key) => (
                                      <button
                                        key={key}
                                        type="button"
                                        onClick={() => handleKey(key)}
                                        className={`order-alpha-key ${
                                          [
                                            "Delete",
                                            "Space",
                                            "Clear",
                                            "Enter",
                                          ].includes(key)
                                            ? "special"
                                            : ""
                                        }`}
                                      >
                                        {key}
                                      </button>
                                    ))}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          <div className="cont-btn-wrap">
                            <button
                              type="button"
                              className="continue-btn"
                              onClick={() => submitCode(code)}
                            >
                              Continue
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentUniversal;
